<div class="container-fluid sticky-header">
    <div class="row">
        <div class="col-sm-12 col-lg-12 logoImg"> 
            <div class="container-fluid py-1"><img class="" src="../../assets/images/logo.svg" alt="" > </div>
        </div>
    </div>
</div>
<div class="py-3 paddingLogin" >
    <div class="login pt-4">
        <div class="leftpart"><img class="mt-3" src="../../assets/images/login.png" alt="" ></div>
        <div class="rightpart pt-5">
            <form class="login-form registration-form forget-password-form" [formGroup]="forgetPasswordForm" *ngIf="!isEmailVerified && !isOtpAuthenticated">
                <h1 class="title text-center">Enter your Registered Email ID</h1>
                <ng-container >
                    <div class="mb-4">
                        <img src="../../assets/images/email.png" alt="" >
                        <input type="email" class="form-control" id="email" placeholder="Email ID" formControlName="email" maxlength="100"
                        (keydown)="removeContactExistErrMsg();">
                        <div *ngIf="forgetPasswordForm.controls['email']!.invalid" class="errMsg">
                            <span *ngIf="(isSubmitted || forgetPasswordForm.controls['email']!.touched || forgetPasswordForm.controls['email']!.dirty) && 
                            forgetPasswordForm.controls['email']!.errors!['required']">This field is required</span>
                            <span *ngIf="isSubmitted && 
                            forgetPasswordForm.controls['email']!.errors!['pattern']">Please provide a valid email address</span>
                        </div>    
                    </div>
                    <div class="row mt-5">
                        <div class="col-lg-8 mb-4 errMsg contactExistErr">
                            <span *ngIf="ifContactExist != undefined && ifContactExist == false">Contact does not exist.</span>
                            <span *ngIf="ifContactExist && isDeactivated">Contact/Assessment Entity has been deactivated.</span>
                        </div>
                        <div class="col-lg-4">
                            <button type="button" class="w-100 btn btn-lg btn-primary" type="submit" (click)="verifyUser()">Submit</button>
                        </div>
                    </div>
                </ng-container>
                </form>
                <form class="login-form registration-form forget-password-form" [formGroup]="setPasswordForm" *ngIf="isEmailVerified && isOtpAuthenticated">
                    <h1 class="title text-center">Set New Password</h1>
                    <ng-container >
                            <div class="mb-2">
                                <label class="passwordNote">Passwords must contain 8-15 characters and at least 1 number, 1 lowercase alphabet, 1 uppercase alphabet, 1 special character (All special characters can be used except ]  \  and spaces).</label>
                            </div>
                            <div class="mb-4">
                                <img src="../../assets/images/pass-avatar.png" alt="" >
                                <input type="text" class="form-control" id="password" placeholder="Enter a New Password" formControlName="password" 
                                maxlength="15" required (keydown)="clearPasswordErr($event)">
                                <div *ngIf="setPasswordForm.controls['password']!.invalid" class="errMsg">
                                    <span *ngIf="(isSubmitted || setPasswordForm.controls['password']!.touched || setPasswordForm.controls['password']!.dirty) && 
                                    (setPasswordForm.controls['password']!.errors &&
                                    setPasswordForm.controls['password']!.errors!['required'])">This field is required</span>
                                    <span *ngIf="isSubmitted && setPasswordForm.controls['password']!.errors && setPasswordForm.controls['password']!.errors!['pattern']">Please follow the valid pattern for password</span>
                                </div>
                            </div>
                            <div class="mb-4">
                                <img src="../../assets/images/pass-avatar.png" alt="" >
                                <input type="password" class="form-control" id="confirmPassword" placeholder="Confirm Password" 
                                formControlName="confirmPassword" required maxlength="15" (keydown)="clearPasswordErr($event)">
                                <div *ngIf="setPasswordForm.controls['confirmPassword']!.invalid" class="errMsg">
                                    <span *ngIf="(isSubmitted || setPasswordForm.controls['confirmPassword']!.touched || setPasswordForm.controls['confirmPassword']!.dirty) && 
                                    (setPasswordForm.controls['confirmPassword']!.errors && setPasswordForm.controls['confirmPassword']!.errors!['required'])">This field is required</span>
                                    <span *ngIf="!setPasswordForm.controls['confirmPassword']!.errors!['required'] && !passwordMatch">Your password and confirmation password do not match.</span>
                                </div>
                                <div *ngIf="setPasswordForm.controls['confirmPassword']!.valid" class="errMsg">
                                    <span *ngIf="isSubmitted && !passwordMatch">Your password and confirmation password do not match</span>
                                </div>
                            </div>
                        
                        
                        <div *ngIf="isSetPassword">
                            <alert type="success" >
                                <p class="successAlert">Password has been set Successfully. <a href="" class="clickHere">Click here</a> to Login.</p>
                            </alert>
                        </div>
                        <div class="row mt-5">
                            <div class="offset-8 col-lg-4">
                                <button type="button" class="w-100 btn btn-lg btn-primary" type="submit" (click)="setPassword()">Submit</button>
                            </div>
                        </div>
                    </ng-container>
                </form>
        </div>
    </div>    
</div>
<div class="footerDiv">
    <app-footer></app-footer>
</div>
